module.exports = __webpack_public_path__ + "static/img/promotion_bg.c73eb73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/promotion_bg.png
// module id = OHyB
// module chunks = 192